import { ReactNode, useCallback } from 'react';

import { IconsEnum } from '../../../../assets/icons/types';
import { PureIconButtonHelper } from '../../../../helpers/buttons/PureIconButtonHelper';
import { StaticImageHelper } from '../../../../helpers/StaticImageHelper';

import { composerKeys, words } from '../../../../locales/keys';

import { buildDownloadName } from '../../../modelViewers/components/content/ModelViewerEditor/utils/buildDownloadName';
import { downloadFile } from '../../../../utils/downloadFile';

interface ComposerRenderResultOverlayProps {
  resultFullUrl: string;
  sceneName?: string;
  downloadType?: string;
  onBack: () => void;
  children?: ReactNode;
}

function ComposerRenderResultOverlay({
  resultFullUrl,
  sceneName,
  downloadType = 'composite-render',
  onBack,
  children
}: ComposerRenderResultOverlayProps) {
  const handleDownload = useCallback(() => {
    downloadFile({
      downloadFile: {
        file: resultFullUrl,
        name: buildDownloadName(sceneName, downloadType, resultFullUrl)
      },
      withBlob: true
    });
  }, [resultFullUrl, sceneName, downloadType]);

  return (
    <div className="absolute inset-0 z-30 bg-white dark:bg-gray-900 flex items-center justify-center">
      <StaticImageHelper
        src={resultFullUrl}
        alt=""
        className="w-full h-full object-contain"
      />

      <div className="absolute bottom-4 left-4 flex items-center gap-2 z-40">
        <PureIconButtonHelper
          icon={IconsEnum.CHEVRON_LEFT}
          iconClassName="h-5 w-5"
          i18nText={composerKeys.backToScene}
          className="py-1.5 pl-1.5 pr-3 space-x-1 rounded-md inline-flex items-center whitespace-nowrap text-sm font-medium leading-5 bg-gray-200 hover:bg-gray-300 text-gray-800 dark:text-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 transition-colors"
          onClick={onBack}
        />
        <PureIconButtonHelper
          icon={IconsEnum.DOWNLOAD_SOLID}
          iconClassName="h-5 w-5"
          i18nText={words.download}
          className="py-1.5 pl-1.5 pr-3 space-x-1 rounded-md inline-flex items-center whitespace-nowrap text-sm font-medium leading-5 bg-gray-200 hover:bg-gray-300 text-gray-800 dark:text-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 transition-colors"
          onClick={handleDownload}
        />
      </div>

      {children}
    </div>
  );
}

export default ComposerRenderResultOverlay;
